import type { InputContentType } from './content-types';
import { ListContentType, OutputContentType } from './content-types';
import type { SupportedVersions } from './content-versions';
import { edenSupportedVersions } from './content-versions';

const typeHeader = (type: string | ListContentType<any>, version: string) =>
    `application/vnd.gc.com.${type}+json; version=${version}`;

function getLatestSupportedVersion(type: keyof SupportedVersions) {
    return edenSupportedVersions[type].slice(-1)[0];
}
export function generateEdenHeaders({
    inputType,
    outputType,
    paginate,
}: {
    inputType: InputContentType;
    outputType: OutputContentType | ListContentType<OutputContentType>;
    paginate: boolean;
}) {
    const inputVersion = getLatestSupportedVersion(inputType);
    edenSupportedVersions[OutputContentType.ATHLETE_PROFILE_CLIPS_PUBLIC];

    const outputVersion =
        outputType instanceof ListContentType
            ? getLatestSupportedVersion(outputType.type)
            : getLatestSupportedVersion(outputType);

    const paginationHeaders = paginate ? { 'x-pagination': 'true' } : undefined;

    return {
        'Content-Type': typeHeader(inputType, inputVersion),
        'gc-app-name': 'web', // Eden wants this on ALL of the web calls, it helps datadog know where the calls come from.
        Accept: typeHeader(outputType, outputVersion),
        ...paginationHeaders,
    };
}
